// Small helpers of the header's buttons (kept free of React so they can be tested).

// The Get Quote button opens the quote window when its address is empty or "#quote"; any other address is a page or link to go to.
export function opensQuoteWindow(url) {
  const value = String(url || "").trim();
  return value === "" || value === "#quote";
}

// The services a visitor can ask about: the names of the active service cards, once each, in their order, plus a way out for "something else".
export const OTHER_SERVICE = "Other / not sure yet";

export function serviceChoices(cards) {
  const seen = new Set();
  const names = [];
  (cards || []).forEach((card) => {
    const title = String((card && card.title) || "").trim();
    if (title && !seen.has(title.toLowerCase())) {
      seen.add(title.toLowerCase());
      names.push(title);
    }
  });
  return [...names, OTHER_SERVICE];
}
